import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation} from "react-router-dom";
import { useGlobalState } from "../../contexts/GlobalContext";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../utils/constants";
import ScaleLoader from "react-spinners/ScaleLoader";
import { fetchSurveyData, fetchUserInfoProxy, handleFetchSurveyData } from "../../utils/helpers/api";
import { shouldBulkDownload } from "../../utils/helpers/function";

export const encodeSurveyUrl = (rawUrl: string) => {
  try {
    const url = new URL(rawUrl);

    const id = url.searchParams.get("id");
    const userId = url.searchParams.get("user_id");

    if (id !== null) {
      url.searchParams.set("id", id);
    }

    if (userId !== null) {
      url.searchParams.set("user_id", userId);
    }

    return url.toString();
  } catch {
    return rawUrl;
  }
};


const Survey: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { survey_id } = location.state ?? {};
  const { globalState, setStateValue } = useGlobalState();
  const { user } = globalState;
  const user_id = user?.user_id;
  const navigate = useNavigate();
  const [state, setState] = useState({
    survey_url: "",
    blob: "",
    type: 0,
  });

  useEffect(() => {
    if (user?.user_metadata?.user_status !== 2) {
      setState({
        type: 4,
        blob: "",
        survey_url: "",
      });
      const timer = setTimeout(() => {
        const returnTo = shouldBulkDownload()
          ? localStorage.getItem("loginCallBackUrl")
          : null;
        const params = new URLSearchParams();
        if (returnTo) params.append("returnto", returnTo);
        const settingPath = `${Routes.USERSETTING}${
          params.toString() ? `?${params.toString()}` : ""
        }`;
        navigate(settingPath, {
          state: { survey: true, survey_id: survey_id },
        });
      }, 5000);

      return () => clearTimeout(timer);
      }
  }, [user?.user_metadata?.user_status]);

  useEffect(() => {
    if (user?.user_metadata?.user_status === 2) {
      if (user_id) handleSurveyApi(true);
    }
  }, [user_id, survey_id]);

  const handleSurveyApi = async (delay: boolean) => {
    setState({
      type: 0,
      blob: "",
      survey_url: "",
    });
    try {
      const response = await fetchUserInfoProxy(1);
      const user_id_hash = response?.data?.user_id_hash ?? "";

      const surveyDataResult = await handleFetchSurveyData(
        survey_id ?? "",
        user_id ?? "",
        delay,
        user_id_hash
      );
      const surveyData= JSON.parse(surveyDataResult.data.body); 
      if (surveyData?.ok) {
        if (surveyData.answered) {
          setState({
            type: 1,
            blob: surveyData.blob,
            survey_url: "",
          });
        } else {
          const encodedSurveyUrl = encodeSurveyUrl(surveyData.survey_url);
          setState({
            type: 2,
            blob: "",
            survey_url: encodedSurveyUrl,
          });
        }
      }
    } catch (error) {
      setState({
        type: 3,
        blob: "",
        survey_url: "",
      });
    } finally {
      localStorage.removeItem("surveyId");
    }
  };

  const handleDownload = () => {
    if (state.blob != "") {
      const binaryString = atob(state.blob);
      const uint8Array = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i);
      }
      const blobPDF = new Blob([uint8Array], { type: "application/pdf" });
      const url = URL.createObjectURL(blobPDF);

      const link = document.createElement("a");
      link.href = url;
      link.download = "survey.pdf";
      link.click();
    }
  };

  const handleRecallSurveyApi = () => {
    handleSurveyApi(true);
  };

  const handleOpenSurvey = () => {
    window.open(state.survey_url, "_blank");
  };

  return (
    <div>
      {state.type === 4 && (
        <Box className="survey_page center mt20">
          <p className="mb4 text_err">ダウンロードには本会員登録が必要です。</p>
          <p className="mb16 text_err">入力画面へ遷移します。</p>
        </Box>
      )}
      {state.type === 1 && (
        <Box className="center mt20">
          <div className="btn btn-primary mt8" onClick={handleDownload}>
            {t("features.survey.btn_download")}
          </div>
        </Box>
      )}

      {state.type === 2 && (
        <Box className="survey_page center mt20">
          <p className="mb4"> {t("features.survey.message1")} </p>
          <p className="mb16"> {t("features.survey.message2")} </p>
          <div className="btn btn-primary mt8" onClick={handleOpenSurvey}>
            {t("features.survey.btn_survey")}
          </div>
          <p className="recall_survey" onClick={handleRecallSurveyApi}> 
            {t("features.survey.surveyAnsweredButVisible")} 
          </p>
        </Box>
      )}
      {state.type === 3 && (
        <Box className="survey_page center mt20">
          <p className="title_err">{t("features.survey.title_err")}</p>
          <p className="mb4 text_err"> {t("features.survey.message_err_1")} </p>
          <p className="mb16 text_err">{t("features.survey.message_err_2")}</p>
        </Box>
      )}
      {state.type === 0 && (
        <div className="components__loader">
          <div className="components__loader-spinner">
            <ScaleLoader color="#fff" height={30} loading={true} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Survey;